<template>
  <v-btn
    color="success"
    class="mt-3"
    @click="$emit('submit')"
  >{{ label }}</v-btn>
</template>

<script>
export default {
  name: 'SubmitButton',
  props: {
    label: {
      type: String,
      default: 'Поиск',
    },
  },
}
</script>